import { memo, useMemo } from "react";

import { RenderResourceRowCellProps } from ".";
import { IAC_MANAGEMENTS_TABLE_COLUMNS } from "../types";
import useCellCopyAction from "../useCellCopyAction";
import { ResourcesSuggestions } from "../../useIacManagementFilters/constants";
import IacManagementTableLink from "../components/Link";
import useIacManagementAnalytics from "../../useIacManagementAnalytics";
import IacManagementResourceCell from "../components/ResourceCell";

const IacManagementTableResourceRowCellAddress = memo((props: RenderResourceRowCellProps) => {
  const { row, handleResourceClick } = props;

  const copyAction = useCellCopyAction(ResourcesSuggestions.ResourceAddress, row.address);
  const actions = useMemo(() => [copyAction], [copyAction]);

  const { analyticPage } = useIacManagementAnalytics();

  return (
    <IacManagementResourceCell {...props} actions={actions} role="rowheader">
      <IacManagementTableLink
        columnId={IAC_MANAGEMENTS_TABLE_COLUMNS.RESOURCE_ADDRESS}
        onPress={handleResourceClick}
        analyticsPage={analyticPage}
        analyticsTitle="Resource Clicked"
        analyticsProps={{ driftDetected: !!row.drifted }}
      >
        {row.address}
      </IacManagementTableLink>
    </IacManagementResourceCell>
  );
});

IacManagementTableResourceRowCellAddress.displayName = "IacManagementTableResourceRowCellAddress";

export default IacManagementTableResourceRowCellAddress;
